// extracted by mini-css-extract-plugin
export var infoItem = "_tr-2";
export var title = "_tr-0";
export var value = "_tr-1";